
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from './is-browser.mjs.js';

var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect };
//# sourceMappingURL=use-isomorphic-effect.mjs.js.map
